import _ from 'lodash'

export const createPagination = ( itemsPerPage, page, callback ) => {
	const pagination = {
		items_per_page: itemsPerPage,
		page: page
	}
	
	if( _.isFunction( callback ) ) {
		callback( page )
	}
	
	return pagination;
}

export const calculatePagination = ( itemsPerPage, currentPage ) => {
	return currentPage * itemsPerPage;
}
